import React from "react";
import { Section, SectionHeading, Reveal } from "./Primitives";
import { SERVICES } from "../../data/content";

export const Services = () => {
  return (
    <Section id="services">
      <SectionHeading overline={SERVICES.overline} title={SERVICES.title} />

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 rounded-3xl overflow-hidden border border-white/5">
        {SERVICES.items.map((s, i) => {
          const Icon = s.icon;
          return (
            <Reveal
              key={s.title}
              delay={(i % 3) * 0.08}
              className="group relative bg-void hover:bg-white/[0.02] transition-colors duration-300 p-8 md:p-10"
            >
              <div className="flex items-center justify-center h-12 w-12 rounded-xl bg-brand/10 border border-brand/20 text-brand mb-6 transition-transform duration-300 group-hover:-translate-y-1">
                <Icon className="h-6 w-6" strokeWidth={1.6} />
              </div>
              <h3 className="font-heading text-xl font-medium text-white">{s.title}</h3>
              <p className="mt-3 text-sm md:text-base leading-relaxed text-muted-foreground">{s.outcome}</p>
              <span className="pointer-events-none absolute left-0 bottom-0 h-px w-0 bg-brand transition-all duration-500 group-hover:w-full" />
            </Reveal>
          );
        })}
        <div className="hidden lg:block bg-void" />
        <div className="hidden lg:block bg-void" />
      </div>
    </Section>
  );
};

export default Services;
